export default __webpack_public_path__ + "assets/pressure-high-alt.b55ac962.svg";